export default __webpack_public_path__ + "static/media/text.f67fc8ce.svg";